const httpName='http://api.ticks.precisiongenes.com.cn/api/v1';
// const httpName='http://192.168.1.63:8001/api/v1';
//const httpName='http://ticks.precisiongenes.com.cn/api/v1';
export default httpName;